export default {
  LOGIN: {
    PATHNAME: "/login",
    TITLE: "",
    AMPLITUDE_TITLE: "Авторизация пациента",
    BREADCRUMB: "Вернуться на страницу авторизации",
  },
  APPOINTMENT: {
    PATHNAME: "/appointment",
    TITLE: "",
    BREADCRUMB: null,
  },
  HOSPITALS: {
    PATHNAME: "/appointment/hospital",
    TITLE: "",
    AMPLITUDE_TITLE: "Список больниц",
    BREADCRUMB: "Вернуться на страницу выбор больниц",
  },
  DOCTORS: {
    PATHNAME: "/appointment/doctor",
    TITLE: "",
    AMPLITUDE_TITLE: "Список врачей",
    BREADCRUMB: "Вернуться на страницу выбора врачей",
  },
  SPECIALTIES: {
    PATHNAME: "/appointment/speciality",
    TITLE: "",
    AMPLITUDE_TITLE: "Список специальностей",
    BREADCRUMB: "Вернуться на страницу выбор специальности",
  },
  DATES: {
    PATHNAME: "/appointment/time",
    TITLE: "",
    AMPLITUDE_TITLE: "Талоны для записи",
    BREADCRUMB: "Вернуться на страницу выбора времени записи",
  },
  JOURNAL: {
    PATHNAME: "/appointment/journal",
    TITLE: "",
    AMPLITUDE_TITLE: "История записи",
    BREADCRUMB: null,
  },
  NOTFOUND: {
    PATHNAME: "*",
    TITLE: "",
    AMPLITUDE_TITLE: "404",
    BREADCRUMB: null,
  },
};
